// ============================================
// MARBLE THEME - Scripts
// ============================================

// Glitch Text → Katakana Effect
const wordMap = {

  // Nav
  'shop': 'ショップ',
  'archive': 'アーカイブ',
  'world': 'ワールド',
  'info': 'インフォ',
  'cart': 'カート',
  
  // Apparel types
  'hoodie': 'フーディー',
  'tee': 'ティー',
  't-shirt': 'Tシャツ',
  'shirt': 'シャツ',
  'sweatshirt': 'スウェットシャツ',
  'shorts': 'ショーツ',
  'pants': 'パンツ',
  'hat': 'ハット',
  'cap': 'キャップ',
  'jacket': 'ジャケット',
  'hooded': 'フーデッド',
  'embroidered': 'エンブロイダード',
  'terry': 'テリー',
  'nylon': 'ナイロン',
  'french': 'フレンチ',
  'cargo': 'カーゴ',
  
  // Product names/series
  'bones': 'ボーンズ',
  'needle': 'ニードル',
  'point': 'ポイント',
  'inu': 'イヌ',
  'skull': 'スカル',
  'wolf': 'ウルフ',
  'okami': 'オオカミ',
  'jorogumo': 'ジョロウグモ',
  'jorōgumo': 'ジョロウグモ',
  'tora': 'トラ',
  'yokai': 'ヨウカイ',
  'hounds': 'ハウンズ',
  'hound': 'ハウンド',
  'hell': 'ヘル',
  'machine': 'マシーン',
  'girl': 'ガール',
  'ankle': 'アンクル',
  'biter': 'バイター',
  'maru': 'マル',
  'split': 'スプリット',
  'throwie': 'スローイー',
  'rewired': 'リワイアード',
  'relax': 'リラックス',
  'awake': 'アウェイク',
  'eyes': 'アイズ',
  'meyes': 'マイズ',
  'digital': 'デジタル',
  'foreshadowing': 'フォアシャドウイング',
  'losing': 'ルージング',
  'it': 'イット',
  'soy': 'ソイ',
  'beyond': 'ビヨンド',
  'oni': 'オニ',
  'creature': 'クリーチャー',
  'cat': 'キャット',
  'dog': 'ドッグ',
  'monster': 'モンスター',
  'headache': 'ヘッドエイク',
  'hoju': 'ホージュ',
  'flame': 'フレイム',
  'yen': 'エン',
  '¥en': 'エン',
  'cerberus':'ケルベロス',
  
  // Accessories & misc products
  'rug': 'ラグ',
  'socks': 'ソックス',
  'striped': 'ストライプ',
  'keychain': 'キーチェーン',
  'key': 'キー',
  'chain': 'チェーン',
  'sticker': 'ステッカー',
  'pack': 'パック',
  'tote': 'トート',
  'bag': 'バッグ',
  'art': 'アート',
  'deck': 'デッキ',
  'print': 'プリント',
  'plate': 'プレート',
  'banner': 'バナー',
  'box': 'ボックス',
  'gacha': 'ガチャ',
  'nobori': 'ノボリ',
  'vertex': 'バーテックス',
  'tire': 'タイヤ',
  'covers': 'カバーズ',
  'hareware': 'ハレウェア',
  'logo': 'ロゴ',
  'peeking': 'ピーキング',
  'air': 'エアー',
  'fresh': 'フレッシュ',
  'peace': 'ピース',
  
  // Descriptors/modifiers
  'faded': 'フェイデッド',
  'washed': 'ウォッシュド',
  'stonewash': 'ストーンウォッシュ',
  'blank': 'ブランク',
  'new': 'ニュー',
  'og': 'OG',
  'golden': 'ゴールデン',
  'leaf': 'リーフ',
  'light': 'ライト',
  'ice': 'アイス',
  'odd': 'オッド',
  'dust': 'ダスト',
  'side': 'サイド',
  'vent': 'ベント',
  'text': 'テキスト',
  'bad': 'バッド',
  'luck': 'ラック',
  'club': 'クラブ',
  'starz': 'スターズ',
  
  // Colors
  'black': 'ブラック',
  'white': 'ホワイト',
  'red': 'レッド',
  'blue': 'ブルー',
  'green': 'グリーン',
  'yellow': 'イエロー',
  'pink': 'ピンク',
  'purple': 'パープル',
  'grey': 'グレー',
  'gray': 'グレー',
  'navy': 'ネイビー',
  'cream': 'クリーム',
  'brown': 'ブラウン',
  'olive': 'オリーブ',
  'wine': 'ワイン',
  'charcoal': 'チャコール',
  'salmon': 'サーモン',
  'mush': 'マッシュ',
  'moss': 'モス',
  'coffee': 'コーヒー',
  'stone': 'ストーン',
  'sage': 'セージ',
  'mint': 'ミント',
  'lilac': 'ライラック',
  'desert': 'デザート',
  'storm': 'ストーム',
  'midnight': 'ミッドナイト',
  'bone': 'ボーン',
  'sunflower': 'サンフラワー',
  'silver': 'シルバー',
  'smoke': 'スモーク',
  
  // Places
  'marble': 'マーブル',
  'yokohama': 'ヨコハマ',
  'tokyo': 'トーキョー',
  'tok¥o': 'トーキョー',
  
  // Sizes
  'small': 'スモール',
  'medium': 'ミディアム',
  'large': 'ラージ',
  
  // Footer
  'shipping': '配送',
  'policies':'ポリシー',
  'returns': '返品',
  'contact': 'コンタクト',
  'instagram': 'インスタグラム'
};

const glitchChars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンー';

function toKatakana(text) {
  let result = text.toLowerCase();
  const sortedWords = Object.keys(wordMap).sort((a, b) => b.length - a.length);
  for (const word of sortedWords) {
    const regex = new RegExp(word, 'gi');
    result = result.replace(regex, wordMap[word]);
  }
  result = result.replace(/ - /g, ' ー ');
  return result;
}
function scrambleText(element, originalText, targetText, duration = 600) {
  const length = targetText.length;
  const steps = 8;
  const stepTime = duration / steps;
  let currentStep = 0;
  
  element.classList.add('glitching');
  
  const interval = setInterval(() => {
    currentStep++;
    let result = '';
    
    for (let i = 0; i < length; i++) {
      const progress = currentStep / steps;
      const charResolved = i < targetText.length * progress;
      
      if (charResolved) {
        result += targetText[i] || '';
      } else if (i < originalText.length) {
        result += glitchChars[Math.floor(Math.random() * glitchChars.length)];
      }
    }
    
    element.textContent = result;
    
    if (currentStep >= steps) {
      clearInterval(interval);
      element.textContent = targetText;
      element.classList.remove('glitching');
    }
  }, stepTime);
  
  return interval;
}

// Apply glitch to nav links
function applyGlitchToLinks(selector) {
  document.querySelectorAll(selector).forEach(link => {
    const englishText = link.textContent;
    const katakanaText = toKatakana(englishText);
    let currentInterval = null;
    
    link.dataset.english = englishText;
    link.dataset.katakana = katakanaText;
    
    link.addEventListener('mouseenter', () => {
      if (currentInterval) clearInterval(currentInterval);
      currentInterval = scrambleText(link, link.textContent, katakanaText, 400);
    });
    
    link.addEventListener('mouseleave', () => {
      if (currentInterval) clearInterval(currentInterval);
      currentInterval = scrambleText(link, link.textContent, englishText, 400);
    });
  });
}

// Initialize glitch effects and eyes
document.addEventListener('DOMContentLoaded', () => {
  // Nav glitch effect
  applyGlitchToLinks('.header-nav-float__link');
  applyGlitchToLinks('.footer__link');
  
  // Product title glitch (katakana default, English on hover)
  document.querySelectorAll('.product-card__title').forEach(title => {
    const englishText = title.textContent;
    const katakanaText = toKatakana(englishText);
    let currentInterval = null;
    
    title.dataset.english = englishText;
    title.dataset.katakana = katakanaText;
    title.textContent = katakanaText;
    
    const card = title.closest('.product-card');
    if (card) {
      card.addEventListener('mouseenter', () => {
        if (currentInterval) clearInterval(currentInterval);
        currentInterval = scrambleText(title, title.textContent, englishText);
      });
      
      card.addEventListener('mouseleave', () => {
        if (currentInterval) clearInterval(currentInterval);
        currentInterval = scrambleText(title, title.textContent, katakanaText);
      });
    }
  });
  
  // Cursor-tracking eyes
  const eyes = document.querySelectorAll('.eye');
  document.addEventListener('mousemove', (e) => {
    if (window.innerWidth <= 700) return;
    
    eyes.forEach(eye => {
      const rect = eye.getBoundingClientRect();
      const eyeCenterX = rect.left + rect.width / 2;
      const eyeCenterY = rect.top + rect.height / 2;
      const angle = Math.atan2(e.clientY - eyeCenterY, e.clientX - eyeCenterX);
      const distance = Math.min(Math.hypot(e.clientX - eyeCenterX, e.clientY - eyeCenterY) / 15, 10);
      const pupil = eye.querySelector('.eye__pupil');
      const x = Math.cos(angle) * distance;
      const y = Math.sin(angle) * distance;
      pupil.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
    });
  });
  
  // Back to top
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 300);
    });
  }
});

// ============================================
// Cart Drawer Toggle (outside DOMContentLoaded)
// ============================================
const drawer = document.getElementById('cart-drawer');
const overlay = document.getElementById('cart-drawer-overlay');
const closeBtn = document.getElementById('cart-drawer-close');
const toggleBtns = document.querySelectorAll('.cart-toggle');

function openDrawer() {
  if (drawer) drawer.classList.add('is-open');
  if (overlay) overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  if (drawer) drawer.classList.remove('is-open');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

toggleBtns.forEach(btn => {
  btn.addEventListener('click', openDrawer);
});

if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
if (overlay) overlay.addEventListener('click', closeDrawer);

const continueBtn = document.getElementById('cart-continue-shopping');
if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeDrawer();
});

// ============================================
// Cart Drawer: Quantity & Remove
// ============================================
document.addEventListener('click', function(e) {
  const target = e.target;
  
  // Remove item
  if (target.classList.contains('cart-drawer__remove')) {
    const line = target.dataset.line;
    const item = target.closest('.cart-drawer__item');
    
    item.style.opacity = '0';
    item.style.transform = 'translateX(20px)';
    
    updateCart(line, 0);
  }
  
  // Quantity buttons
  if (target.classList.contains('cart-drawer__qty-btn')) {
    const line = parseInt(target.dataset.line);
    const action = target.dataset.action;
    const item = target.closest('.cart-drawer__item');
    const qtyDisplay = item.querySelector('.cart-drawer__qty-num');
    let qty = parseInt(qtyDisplay.textContent);
    
    if (action === 'increase') {
      qty++;
    } else if (action === 'decrease' && qty > 1) {
      qty--;
    } else if (action === 'decrease' && qty === 1) {
      item.style.opacity = '0';
      item.style.transform = 'translateX(20px)';
      updateCart(line, 0);
      return;
    }
    
    qtyDisplay.textContent = qty;
    updateCart(line, qty);
  }
});

function updateCart(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: parseInt(line), quantity: quantity })
  })
  .then(res => res.json())
  .then(cart => {
    document.querySelectorAll('.cart-toggle').forEach(btn => {
      btn.textContent = `cart (${cart.item_count})`;
    });
    
    const title = document.querySelector('.cart-drawer__title');
    if (title) title.textContent = `cart (${cart.item_count})`;
    
    const total = document.querySelector('.cart-drawer__total');
    if (total) {
      const formattedTotal = (cart.total_price / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: cart.currency
      });
      total.textContent = `total: ${formattedTotal}`;
    }
    
    if (quantity === 0) {
      setTimeout(() => {
        const item = document.querySelector(`.cart-drawer__item[data-line="${line}"]`);
        if (item) item.remove();
        
        document.querySelectorAll('.cart-drawer__item').forEach((el, i) => {
          const newLine = i + 1;
          el.dataset.line = newLine;
          el.querySelectorAll('[data-line]').forEach(child => {
            child.dataset.line = newLine;
          });
        });
        
        if (cart.item_count === 0) {
          const items = document.querySelector('.cart-drawer__items');
          const footer = document.querySelector('.cart-drawer__footer');
          if (items) items.innerHTML = '<p class="cart-drawer__empty">your cart is empty</p>';
          if (footer) footer.remove();
        }
      }, 200);
    }
    
    if (quantity > 0) {
      const item = document.querySelector(`.cart-drawer__item[data-line="${line}"]`);
      if (item && cart.items[line - 1]) {
        const priceEl = item.querySelector('.cart-drawer__item-price');
        if (priceEl) {
          const linePrice = (cart.items[line - 1].final_line_price / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: cart.currency
          });
          priceEl.textContent = linePrice;
        }
      }
    }
  });
}

// ============================================
// AJAX Add to Cart (with scramble + drawer update + color flash)
// ============================================
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (form.action && form.action.includes('/cart/add')) {
    e.preventDefault();
    
    const submitBtn = form.querySelector('[type="submit"], button:not([type="button"])');
    const originalText = submitBtn ? submitBtn.textContent.trim() : 'add to cart';
    const successText = 'カート追加';
    
    const formData = new FormData(form);
    
    if (submitBtn) submitBtn.disabled = true;
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(item => {
      // Fetch full cart to get updated state
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Update cart count
          document.querySelectorAll('.cart-toggle').forEach(btn => {
            btn.textContent = `cart (${cart.item_count})`;
          });
          
          const drawerTitle = document.querySelector('.cart-drawer__title');
          if (drawerTitle) drawerTitle.textContent = `cart (${cart.item_count})`;
          
          // Update total
          const total = document.querySelector('.cart-drawer__total');
          if (total) {
            const formattedTotal = (cart.total_price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: cart.currency
            });
            total.textContent = `total: ${formattedTotal}`;
          }
          
          // Rebuild cart drawer items
          const itemsContainer = document.querySelector('.cart-drawer__items');
          if (itemsContainer && cart.items.length > 0) {
            itemsContainer.innerHTML = cart.items.map((cartItem, index) => `
              <div class="cart-drawer__item" data-line="${index + 1}">
                <img src="${cartItem.image ? cartItem.image.replace(/(\.[^.]+)$/, '_120x$1') : ''}" alt="${cartItem.title}" class="cart-drawer__item-image">
                <div class="cart-drawer__item-info">
                  <p class="cart-drawer__item-title">${cartItem.product_title}</p>
                  <p class="cart-drawer__item-variant">${cartItem.variant_title || ''}</p>
                  <p class="cart-drawer__item-price">$${(cartItem.final_line_price / 100).toFixed(2)}</p>
                  <div class="cart-drawer__qty">
                    <button class="cart-drawer__qty-btn" data-action="decrease" data-line="${index + 1}">−</button>
                    <span class="cart-drawer__qty-num">${cartItem.quantity}</span>
                    <button class="cart-drawer__qty-btn" data-action="increase" data-line="${index + 1}">+</button>
                  </div>
                </div>
                <button class="cart-drawer__remove" data-line="${index + 1}">remove</button>
              </div>
            `).join('');
          }
          
          // Add footer if it doesn't exist
          let footer = document.querySelector('.cart-drawer__footer');
          if (!footer && cart.items.length > 0) {
            const drawer = document.getElementById('cart-drawer');
            footer = document.createElement('div');
            footer.className = 'cart-drawer__footer';
            footer.innerHTML = `
              <p class="cart-drawer__total">total: $${(cart.total_price / 100).toFixed(2)}</p>
              <a href="/checkout" class="cart-drawer__checkout">checkout</a>
            `;
            drawer.appendChild(footer);
          }
        });
      
      // Scramble button + color flash
      if (submitBtn) {
        submitBtn.classList.add('added');
        scrambleText(submitBtn, originalText, successText, 400);
        
        setTimeout(() => {
          scrambleText(submitBtn, successText, originalText, 400);
          setTimeout(() => {
            submitBtn.classList.remove('added');
            submitBtn.disabled = false;
          }, 400);
        }, 1000);
      }
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
      if (submitBtn) submitBtn.disabled = false;
    });
  }
});
// ============================================
// Word-level Glitch on Hover
// ============================================
function initWordGlitch() {
  document.querySelectorAll('.glitch-text').forEach(container => {
    const paragraphs = container.querySelectorAll('p');
    
    paragraphs.forEach(p => {
      const text = p.textContent;
      const words = text.split(/(\s+)/); // Keep whitespace
      
      p.innerHTML = words.map(word => {
        if (word.trim() === '') return word; // Keep whitespace as-is
        const katakana = toKatakana(word);
        return `<span class="glitch-word" data-english="${word}" data-katakana="${katakana}">${word}</span>`;
      }).join('');
    });
    
    // Add hover listeners
    container.querySelectorAll('.glitch-word').forEach(word => {
      let currentInterval = null;
      const english = word.dataset.english;
      const katakana = word.dataset.katakana;
      
      word.addEventListener('mouseenter', () => {
        if (currentInterval) clearInterval(currentInterval);
        currentInterval = scrambleText(word, word.textContent, katakana, 300);
      });
      
      word.addEventListener('mouseleave', () => {
        if (currentInterval) clearInterval(currentInterval);
        currentInterval = scrambleText(word, word.textContent, english, 300);
      });
    });
  });
}

// Run after DOM ready
document.addEventListener('DOMContentLoaded', initWordGlitch);

// ============================================
// Animated Search Placeholder
// ============================================
function animateSearchPlaceholder() {
  const placeholder = document.getElementById('search-placeholder');
  const input = document.getElementById('animated-search');
  if (!placeholder || !input) return;
  
  const englishText = 'search...';
  const katakanaText = 'サーチ...';
  let currentText = '';
  let isTyping = true;
  let isEnglish = true;
  let charIndex = 0;
  
  function type() {
    const targetText = isEnglish ? englishText : katakanaText;
    
    if (isTyping) {
      // Typing forward
      if (charIndex < targetText.length) {
        currentText += targetText[charIndex];
        placeholder.textContent = currentText;
        charIndex++;
        setTimeout(type, 100 + Math.random() * 50);
      } else {
        // Pause at end, then start deleting
        setTimeout(() => {
          isTyping = false;
          type();
        }, 2000);
      }
    } else {
      // Deleting
      if (currentText.length > 0) {
        currentText = currentText.slice(0, -1);
        placeholder.textContent = currentText;
        setTimeout(type, 50);
      } else {
        // Switch language and start typing again
        isEnglish = !isEnglish;
        isTyping = true;
        charIndex = 0;
        setTimeout(type, 500);
      }
    }
  }
  
  // Don't animate if input is focused
  input.addEventListener('focus', () => {
    placeholder.style.display = 'none';
  });
  
  input.addEventListener('blur', () => {
    if (input.value === '') {
      placeholder.style.display = 'block';
    }
  });
  
  // Start animation
  type();
}

// Initialize
document.addEventListener('DOMContentLoaded', animateSearchPlaceholder);

// Mobile Menu
function initMobileMenu() {
  const toggle = document.getElementById('mobile-menu-toggle');
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mobile-drawer-overlay');
  const close = document.getElementById('mobile-drawer-close');
  
  if (!toggle || !drawer) return;
  
  function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  
  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  
  toggle.addEventListener('click', openDrawer);
  close.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
}

document.addEventListener('DOMContentLoaded', initMobileMenu);

// ============================================
// Product Accordion
// ============================================
function initProductAccordion() {
  document.querySelectorAll('.product-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.product-accordion__item');
      const isOpen = item.classList.contains('open');
      
      // Close all others (optional - remove if you want multiple open)
      document.querySelectorAll('.product-accordion__item').forEach(i => {
        i.classList.remove('open');
      });
      
      // Toggle current
      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });
}

// ============================================
// Mobile Sticky Bar - Option Selection
// ============================================
function initMobileStickyBar() {
  const stickyBar = document.querySelector('.product-sticky-bar');
  if (!stickyBar) return;

  const optionButtons = stickyBar.querySelectorAll('.product-sticky-bar__option');
  const addToCartBtn = document.getElementById('mobile-add-to-cart');
  const priceEl = stickyBar.querySelector('.product-sticky-bar__price');
  
  // Get product data from the page
  const productForm = document.querySelector('form[action="/cart/add"]');
  const variantSelect = productForm ? productForm.querySelector('select[name="id"]') : null;
  
  optionButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionIndex = btn.dataset.optionIndex;
      const value = btn.dataset.optionValue;
      
      // Update selected state in this option group
      stickyBar.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(sibling => {
        if (sibling.classList.contains('product-sticky-bar__option')) {
          sibling.classList.remove('selected');
        }
      });
      btn.classList.add('selected');
      
      // Find matching variant
      updateVariantFromOptions();
    });
  });
  function updateVariantFromOptions() {
    const selectedOptions = [];
    stickyBar.querySelectorAll('.product-sticky-bar__options').forEach(group => {
      const selected = group.querySelector('.product-sticky-bar__option.selected');
      if (selected) {
        selectedOptions.push(selected.dataset.optionValue);
      }
    });

    // Find variant that matches all selected options
    if (window.productVariants) {
      const variant = window.productVariants.find(v => {
        return selectedOptions.every((opt, i) => v.options[i] === opt);
      });
      if (variant) {
        // Update hidden select
        if (variantSelect) {
          variantSelect.value = variant.id;
        }

        // Update price
        if (priceEl) {
          priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
        }

        // Update button state
        if (addToCartBtn) {
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold Out';
          }
        }
      }
    }
  }

  // Mobile add to cart - trigger the main form
  if (addToCartBtn && productForm) {
    addToCartBtn.addEventListener('click', () => {
      productForm.dispatchEvent(new Event('submit', { bubbles: true }));
    });
  }
}

document.addEventListener('DOMContentLoaded', initProductAccordion);
document.addEventListener('DOMContentLoaded', initMobileStickyBar);